import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { NativeProps } from '@/src/components/interfaces';
import { AlignItems, CFlex, JustifyContent } from '@/src/components/c-flex/CFlex';

export enum CAvatarShape {
  Square = 'square',
  Circular = 'circular'
}

export enum CAvatarColor {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Accent1 = 'accent-1',
  Accent1Contrast = 'accent-1-contrast',
  Accent2 = 'accent-2',
  Accent2Contrast = 'accent-2-contrast',
  Accent5 = 'accent-5',
  Accent5Contrast = 'accent-5-contrast',
  Accent6 = 'accent-6',
  Accent6Contrast = 'accent-6-contrast',
}

export enum CAvatarSize {
  Lg = 'lg',
  Md = 'md'
}

export interface CAvatarProps extends NativeProps {
  shape?: CAvatarShape;
  size?: CAvatarSize;
  color?: CAvatarColor;
}

export function CAvatar(props: PropsWithChildren<CAvatarProps>): React.JSX.Element {
  const shape = props.shape ?? CAvatarShape.Circular;
  const size = props.size ?? CAvatarSize.Md;

  return (
    <CFlex
      onClick={props.onClick}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      class={classNames(
        'c-avatar',
        `c-avatar--size-${size}`,
        `c-avatar--shape-${shape}`, {
          [`c-avatar--color-${props.color}`]: props.color,
        }, props.class)}
      style={props.style}
      id={props.id}
      data-test-selector={props.testSelector}
    >
      {props.children}
    </CFlex>
  );
}